export const validateNoSpecialChars = (value: string) =>
  /^[a-zA-Z0-9 _-]*$/.test(value) || "No special characters";
